import { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Preact from 'preact';
import * as BasketNavigation from './M_BasketNavigation';
import * as SnapshotContainer from './M_BasketSnapshotContainer';
import { isSmallScreen } from './domain/theme/breakpoints';
import { ArModal } from './index';

export interface Props {
    sofaSnapshot?: string;
    snapshotLoading: boolean;
    onBasketViewClose: () => void;
    linkProps: (ArModal.ArProps | ArModal.QrProps);
    onViewInRoomClick?: () => void;
    sx?: SxProps;
}

export const Component = (p: Props) => {
    const theme = useTheme();
    const isSmall = isSmallScreen(theme);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                alignItems: 'center',
                justifyContent: 'flex-start',
            }}
        >
            <BasketNavigation.Component title="Sofa Summary" onCloseClick={p.onBasketViewClose} />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    borderRadius: '16px',
                    backgroundColor: '#F5F5F5',
                    padding: '24px 23px',
                    height: isSmall ? '270px' : '100%',
                    width: '100%',
                    maxWidth: isSmall ? 'none' : '398px',
                    marginBottom: isSmall ? '0' : '24px',
                    ...p.sx,
                }}
            >
                <SnapshotContainer.Component
                    sofaSnapshot={p.sofaSnapshot}
                    snapshotLoading={p.snapshotLoading}
                    onViewInRoomClick={p.onViewInRoomClick}
                    linkProps={p.linkProps}
                />
            </Box>
        </Box>
    );
};

Component.displayName = 'BasketSnapshot';
